import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext({ rates: null, updatedAt: null });

export function CurrencyProvider({ children }) {
  const [rates, setRates] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);

  useEffect(() => {
    let live = true;
    api
      .get("/currency/rates")
      .then((r) => {
        if (!live) return;
        setRates(r.data?.rates || null);
        setUpdatedAt(r.data?.updated_at || null);
      })
      .catch(() => {
        /* leave rates null; callers should render only INR */
      });
    return () => {
      live = false;
    };
  }, []);

  return (
    <CurrencyContext.Provider value={{ rates, updatedAt }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
